import React, { useEffect, useRef, useState } from "react";
import PricingHeader from "./PricingHeader";

import PaymentDetails from "./PaymentDetails";
import PaymentInfo from "./PaymentInfo";
import { CheckCircle } from "../../icons/pricingListIcons";
import { Box } from "@material-ui/core";
import FadeContainer from "./FadeContainer";
import { useHistory, Redirect } from "react-router-dom";
import { plans } from "../../data/plans";
import { connect } from "react-redux";

function PaymentSuccessful({
  open,
  handleClose,
  setCurrentDialog,
  currency,
  vehiclesCount
}) {
  const history = useHistory();
  const locationState = useRef(history.location.state || {});
  const [dataLayerSet, setDataLayerSet] = useState(false);

  const chosenPlan = plans.find(
    plan => plan.title === locationState.current.chosenPlan
  );

  useEffect(() => {
    if (!dataLayerSet) {
      if (locationState.current.activating) {
        const date = new Date();
        const currentDate = date.getDate() - 1;
        const daysInMonth = new Date(
          date.getFullYear(),
          date.getMonth() + 1,
          0
        ).getDate();
        const dataForLayer = {
          page_type: "purchase",
          event: "routetitan_purchase",
          currency: currency.string,
          totalValue: (
            ((daysInMonth - currentDate) *
              chosenPlan.price *
              (chosenPlan.name === "individual" ? 1 : vehiclesCount)) /
            daysInMonth
          ).toFixed(2),
          productName: chosenPlan.title,
          productPrice: chosenPlan.price,
          productQuantity: vehiclesCount,
          productId: chosenPlan.name
        };
        window.dataLayer.push(dataForLayer);
        setDataLayerSet(true);
      }
    }
  }, [chosenPlan, currency.string, dataLayerSet, vehiclesCount]);

  return chosenPlan && currency ? (
    <FadeContainer open={open}>
      <PricingHeader
        title={
          <Box component={"span"} display="flex" alignItems="center">
            {locationState.current.action === "plan_change"
              ? "Plan successfully modified "
              : locationState.current.action === "processing"
              ? "Payment initiated"
              : "Payment successful"}
            <CheckCircle success style={{ marginLeft: "12px" }} />
          </Box>
        }
        handleClose={handleClose}
      />
      <PaymentDetails
        chosenPlan={chosenPlan}
        currency={currency}
        successWindow={true}
      />
      <PaymentInfo
        setCurrentDialog={setCurrentDialog}
        title={
          locationState.current.action === "plan_change"
            ? `You’ve changed to a ${chosenPlan.title} plan for Routetitan!`
            : "Thank you for subscribing to Routetitan!"
        }
        subtitle={
          locationState.current.isSepa
            ? `Your purchase from Routetitan will be debited from your bank account within 2 days. This transaction will appear on your bank statement as “Storegear B V”, with a mandate reference YH9A7BCNE5NGUBFP and credit identifier NL 18ZZZ630533060000.
            \n Subscriptions automatically renew unless you cancel them. You can cancel, downgrade or upgrade at any time. Price automatically updates when you add or remove vehicles.`
            : "Subscriptions automatically renew unless you cancel them. You can cancel, downgrade or upgrade at any time. Price automatically updates when you add or remove vehicles."
        }
        btn={{
          text: "Done",
          action: () => handleClose(),
          isGreen: true
        }}
        chosenPlan={chosenPlan}
      />
    </FadeContainer>
  ) : (
    <>
      <Redirect to={`/${sessionStorage.currentProject || ""}`} />
    </>
  );
}
const mapStateToProps = state => ({
  vehiclesCount: state.project.vehicleTypes.length
});

export default connect(mapStateToProps)(PaymentSuccessful);
